import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { apiConfig } from "../../api/apiConfig";
import qs from "qs";

// const baseQuery = fetchBaseQuery(apiConfig);

// const baseQueryWithReauth = async (args, api, extraOptions) => {
//   let result = await baseQuery(args, api, extraOptions);

//   if (result.error && result.error.status === 401) {
//     alert("Session หมดอายุ กรุณาเข้าสู่ระบบใหม่!");
//     window.location.href = "/login"; // รีไดเรกต์ไปหน้า Login
//     localStorage.clear();
//     // navigate("/login");
//   }

//   return result;
// };

export const userManagementApi = createApi({
  reducerPath: "userManagementApi",
  baseQuery: fetchBaseQuery(apiConfig),
  tagTypes: ["UserManagement"],
  endpoints: (builder) => ({
    getAllUser: builder.query({
      query: (payload) => ({
          url: `/users?page=${payload + 1}`,
          method: "GET"
      }),
      providesTags: ["UserManagement"],
    }),
    // addCustomer: builder.mutation({
    //   invalidatesTags: ["Customer"],
    //   query: (payload) => ({
    //     url: `/customers`,
    //     method: "POST",
    //     body: payload,
    //   }),
    // }),
    // updateCustomer: builder.mutation({
    //   invalidatesTags: ["Customer"],
    //   query: (payload) => ({
    //     url: `/customers/${payload.cus_id}`,
    //     method: "PUT",
    //     body: payload,
    //   }),
    // }),
    // delCustomer: builder.mutation({
    //   invalidatesTags: ["Customer"],
    //   query: (cus_id) => ({
    //     url: `/customers/${cus_id}`,
    //     method: "DELETE",
    //   }),
    // }),
    // updateRecall: builder.mutation({
    //   invalidatesTags: ["Customer"],
    //   query: (payload) => ({
    //     url: `/customerRecall/${payload.cd_id}`,
    //     method: "PUT",
    //     body: payload,
    //   }),
    // }),
  }),
});

export const {
  useGetAllUserQuery,
  // useAddCustomerMutation,
  // useUpdateCustomerMutation,
  // useDelCustomerMutation,
  // useUpdateRecallMutation,
} = userManagementApi;
